import React, { forwardRef } from "react";
import styled from "styled-components";

import { FlexLayout } from "js/Components/FlexLayout";
import { Button } from "js/Components/Button";
import { themeColors } from "js/react/sharedStyles";
import { t } from "js/i18n";

const SubmitButton = styled(Button) <{ fullWidth?: boolean }>`
    width: ${props => props.fullWidth ? "100%" : "200px"};
`;

const CancelButton = styled(Button)`
    background: transparent;
    color: ${themeColors.ui_blue};
`;

interface SubmissionButtonsProps {
    disabled?: boolean;
    cancelDisabled?: boolean;
    submitLabel: string;
    cancelLabel?: string;
    onSubmit: () => void;
    onCancel?: () => void;
}

export const SubmissionButtons = forwardRef<HTMLButtonElement, SubmissionButtonsProps>(({ disabled, cancelDisabled, submitLabel, cancelLabel, onSubmit, onCancel }: SubmissionButtonsProps, ref) => {
    return (
        <FlexLayout direction="row" align="center" justify="space-between" width="fill">
            <SubmitButton
                ref={ref}
                data-test-id="payment-form-submit-button"
                onClick={onSubmit}
                disabled={disabled}
                fullWidth={!onCancel}
                blue large
                onKeyDown={(e: React.KeyboardEvent) => {
                    if (!disabled && (e.key === "Enter" || e.key === " ")) {
                        e.preventDefault();
                        onSubmit();
                    }
                }}
            >
                {submitLabel}
            </SubmitButton>
            {onCancel && (
                <CancelButton
                    data-test-id="payment-form-cancel-button"
                    onClick={onCancel}
                    disabled={cancelDisabled}
                    large
                >
                    {cancelLabel || t("Cancel")}
                </CancelButton>
            )}
        </FlexLayout>
    );
});

SubmissionButtons.displayName = "SubmissionButtons";
